import StoriesNavigation from "~/components/StoriesNavigation";
import { getCommonSliceProps } from "~/external/prismic";
import connectSlice from "~/lib/connectSlice";

function mapSliceToProps(slice) {
  const { primary, items, merged } = slice;

  const props = {
    ...getCommonSliceProps(slice),
    columnsOnDesktop: primary.columns_on_desktop || 3,
    columnsOnMobile: primary.columns_on_mobile || 1,
    merged,
  };

  return props;
}

export default connectSlice(mapSliceToProps)(StoriesNavigation);
